<template>
  <nav class="navigator">
    <ul class="navigator__cont">
      <li
        class="navigator__item"
        v-for="(voice, index) in voices[getCity]" :key="index"
        @click="checkMobileMenu ? toggleMenu() : false"
      >
        <router-link
          class="ui-link"
          :to="`/${getCity}/${voice.url}`"
          :data-hover="voice.voice"
        >
          {{ voice.voice }}
        </router-link>
      </li>

      <BaseButton class="navigator__button u-hidden--until-menuL" :data="dataButton" />
    </ul>

    <div
      class="navigator__footer u-hidden--from-menuL u-hidden--until-mobile"
      :class="[isMobileSafari() ? 'safari-fix' : false]"
    >
      <div class="navigator__footer__wrapper">
        <svg class="navigator__stamp" ref="stamp">
          <use :xlink:href="getCity === 'amsterdam' ? '#ams-stamp' : getCity === 'san-francisco' ? '#sf-stamp' : '#ny-stamp'" />
        </svg>
        <div class="navigator__footer__text">
          <strong>Hi Guys</strong>
          <p>Greetings from<br>
          {{ city }} 👋</p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

import { isMobileSafari } from '@/scripts/utils';

import BaseButton from '@/components/BaseButton';


export default {
  name: 'navigator',

  components: {
    BaseButton,
  },

  props: {
    toggleMenu: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      voices: {
        amsterdam: [
          { voice: 'home', url: '' },
          { voice: 'speakers', url: 'speakers' },
          { voice: 'schedule', url: 'schedule' },
          { voice: 'meetup', url: 'adobe-meetup' },
          { voice: 'workshops', url: 'workshops' },
          { voice: 'venues', url: 'venues' },
        ],
        'san-francisco': [
          { voice: 'home', url: '' },
          { voice: 'speakers', url: 'speakers' },
          { voice: 'schedule', url: 'schedule' },
          { voice: 'workshops', url: 'workshops' },
          { voice: 'venues', url: 'venues' },
        ],
        'new-york': [
          { voice: 'home', url: '' },
          { voice: 'speakers', url: 'speakers' },
          { voice: 'schedule', url: 'schedule' },
          { voice: 'workshops', url: 'workshops' },
          { voice: 'venues', url: 'venues' },
        ],
      },
      checkMobileMenu: window.innerWidth <= 730,
      isMobileSafari,
    };
  },

  computed: {
    ...mapGetters(['getCity']),
    dataButton() {
      const button = {
        content: 'Get Tickets',
      };
      if (this.getCity === 'new-york') button.url = 'https://www.universe.com/events/designing-new-experiences-to-sell-more-tickets-new-york-39DKQN';
      return button;
    },

    city() {
      return this.getCity === 'san-francisco' ? 'San Francisco' : 'New York';
    },
  },

  mounted() {
    this.$eventHub.$on('windowResize', this.setMobileMenu);
  },

  methods: {
    setMobileMenu() {
      this.checkMobileMenu = window.innerWidth <= 730;
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('windowResize', this.setMobileMenu);
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  position: fixed;
  top: 76px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 75px);
  height: calc((var(--vh, 1vh) * 100) - 75px);
  background-color: $color-white;
  padding: 25px 20px;

  pointer-events: none;

  backface-visibility: hidden;

  &__cont {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
  }

  &__item {
    position: relative;
    flex: 1 1 0;

    display: flex;
    align-items: center;

    touch-action: manipulation;

    a {
      text-transform: capitalize;
      font-size: font-size(m);
      font-weight: 700;

      &.router-link-exact-active {
        @at-root [data-conference="new-york"] & {
          color: $color-azure;
        }
      }
    }
  }

  &__footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0 25px 0 40px;

    transform: translate3d(0, 50%, 0);
    opacity: 0;

    transition: all 0.4s ease-out 0.6s;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 60%;
      width: 100%;
      background: #F2F2F2;
      z-index: 0;
    }

    &.safari-fix {
      // padding-bottom: 64px;

      strong {
        // margin-bottom: 20px !important;
      }

      // &::before {
      //   height: 65%;
      // }
    }

    &__wrapper {
      position: relative;
      z-index: 1;

      display: flex;
      flex-flow: row wrap;
      align-items: center;

      padding-bottom: 15px;
    }

    &__text {
      margin-left: 30px;

      strong {
        display: block;
        margin-bottom: 10px;

        @at-root [data-conference="new-york"] & {
          color: $color-azure;
        }
      }

      p {
        padding-top: 10px;
      }
    }
  }
  
  &__stamp {
    width: 100px;
  }

  @include mq($until: menuL, $and: $is-portrait) {
    padding: 45px 20px 180px 68px;
  }

  @include mq($until: menuL) {
    clip-path: inset(0% 0% 100% 0%);
    opacity: 0;

    backface-visibility: hidden;

    transition: clip-path 0.4s ease-out,
      opacity 0.4s ease-out 0.2s;

    will-change: clip-path, opacity;

    .navigator__cont {
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .navigator__item {
      display: inline-block;
      opacity: 0;
      transform: translate3d(0px, 20px, 0px);

      flex: 0 0 auto;
      margin: 0 0 20px 0;

      backface-visibility: hidden;

      will-change: transform, opacity;
    }

    &.navigator--open {
      clip-path: inset(0% 0% 0% 0%);
      opacity: 1;
      pointer-events: auto;

      .navigator__item {
        opacity: 1;
        transform: translate3d(0px, 0px, 0px);

        &:nth-child(1) {
          transition: all 0.3s $global-ease 0.4s;
        }

        &:nth-child(2) {
          transition: all 0.3s $global-ease 0.45s;
        }

        &:nth-child(3) {
          transition: all 0.3s $global-ease 0.5s;
        }

        &:nth-child(4) {
          transition: all 0.3s $global-ease 0.55s;
        }

        &:nth-child(5) {
          transition: all 0.3s $global-ease 0.6s;
        }

        &:nth-child(6) {
          transition: all 0.3s $global-ease 0.65s;
        }
      }

      .navigator__footer {
        opacity: 1;
        transform: translate3d(0, 0%, 0);
      }
    }
  }

  @include mq(menuL) {
    position: relative;
    top: 0;
    height: auto;
    max-width: 640px;
    // max-width: 560px;
    padding: 0;
    margin-left: 30px;

    background-color: transparent;
    pointer-events: auto;

    &__cont {
      position: relative;
      width: 100%;

      display: inline-flex;
      flex-flow: row nowrap;
      align-items: baseline;
      justify-content: space-between;
    }

    &__item {
      flex: 0 1 auto;

      a {
        font-size: font-size(s);
      }
    }

    &__button {
      display: inline-block;
    }
  }

  @include mq(ipadP) {
    margin-left: 15px;
  }

  @include mq(ipadL) {
    margin-left: 60px;
  }
}
</style>
